<template>
    <div class="mobile-nav-foot">
        <v-container>
            <slot />
        </v-container>
    </div>
</template>

<script>
export default {
    props: {},
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
